import styled from 'styled-components/macro';

export const StyledMessage = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  padding: 20px;
`;
